import { useColorModeValue } from "@vygruppen/spor-react";

import {
  getSeasonalIllustrationKey,
  isSeasonalIllustrationKey,
} from "~/features/seasonal-decor/seasonal-illustrations/utils";
import { SEASONAL_ILLUSTRATIONS } from "./constants";
import { type IllustrationVariant } from "./types";

export const useSeasonalIllustration = <DefaultKey extends string>(
  defaultKey: DefaultKey,
  variant?: IllustrationVariant,
) => {
  const isDarkmode = useColorModeValue(false, true);
  const key = getSeasonalIllustrationKey();

  const slugs =
    key && isSeasonalIllustrationKey(key) ? SEASONAL_ILLUSTRATIONS[key] : null;

  if (!slugs) {
    return defaultKey;
  }

  const colorModeSlug = isDarkmode ? slugs.dark : slugs.light;

  return variant ? slugs[variant] : colorModeSlug;
};
